import {useState} from 'react';
import s from './ReviewSummary.module.scss';
import StarRating from '../../components/StarRating/StarRating';
import {useNavigate} from 'react-router-dom';
import ReviewModal from '../../components/Modal/ReviewModal'
import Pagination from '../../components/Pagination/Pagination';
import Button from '../../components/Button/Button';

const ReviewSummary = ({ data, reviews, onReviewSubmitted, className, isList= false }) => {
  const [expandedReviews, setExpandedReviews] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reviewsPerPage] = useState(10);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const navigate = useNavigate();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const toggleReview = (id) => {
    setExpandedReviews((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const toggleShowAllReviews = () => {
    navigate(`/review/${data.tour_id}`);
  };

  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews = reviews.slice(indexOfFirstReview, indexOfLastReview);
  const totalPages = Math.ceil(reviews.length / reviewsPerPage);
  const visibleReviews = reviews.slice(0, 3);


  return (
    <div className={`${s.root} ${className}`}>
      <div className={s.reviewsDetails}>
        <div className={s.reviewDetail}>
          {!isList &&
            <h3>口コミ</h3>
          }
          <div className={s.ratingWrapper}>
            <div className={s.totalRating}>
            {data.review_count > 0 ? (
              <StarRating score={data.rating} reviewCount={data.review_count} className={s.number} />
              ) : (
                <span>まだ口コミがありません</span>
              )}
            </div>
            <div className={s.totalRatingBtn}>
              <Button onClick={openModal} label="レビューを書く" />
            </div>
          </div>
        </div>
        <div className={s.reviewList}>
        {!isList ? (
            reviews.slice(0,3).map((review) => (
                <>
              <div key={review.id} className={s.reviewItem}>
                <div className={s.rateAndDate}>
                  <div className={s.nameAndRate}>
                    <span className={s.name}>{review.name}</span>
                    <StarRating score={review.rating} />
                  </div>
                  <div className={s.date}>{review.participation_date}</div>
                  <span className={s.category}>{review.attribute}</span>
                </div>
                <h4 className={s.title}>{review.title}</h4>
                <div className={`${s.content} ${expandedReviews[review.id] ? s.expanded : ''}`}>
                  {expandedReviews[review.id] ? review.body : (review.body.length > 100 ? review.body.slice(0, 100) + '...' : review.body)}
                  {review.body.length > 100 && (
                    <span className={s.toggleReviewButton} onClick={() => toggleReview(review.id)}>
                      {expandedReviews[review.id] ? '閉じる' : '続きを読む'}
                    </span>
                  )}
                </div>
              </div>

                </>
            ))
          ) : (
            currentReviews.map((review) => (
              <div key={review.id} className={s.reviewItem}>
                <div className={s.rateAndDate}>
                  <StarRating score={review.rating} />
                  <div className={s.date}>投稿日：{review.participation_date}</div>
                  <span className={s.name}>{review.name}</span>
                  <span className={s.category}>{review.attribute}</span>
                </div>
                <h4 className={s.title}>{review.title}</h4>
                <div className={`${s.content} ${expandedReviews[review.id] ? s.expanded : ''}`}>
                  {expandedReviews[review.id] ? review.body : (review.body.length > 100 ? review.body.slice(0, 100) + '...' : review.body)}
                  {review.body.length > 100 && (
                    <span className={s.toggleReviewButton} onClick={() => toggleReview(review.id)}>
                      {expandedReviews[review.id] ? '閉じる' : '続きを読む'}
                    </span>
                  )}
                </div>
              </div>
            ))
          )}
          {!isList && reviews.length > 3 && (
          <div className={s.showMore} onClick={toggleShowAllReviews}>
            もっと見る
          </div>
        )}
        </div>

        <ReviewModal isOpen={isModalOpen} onClose={closeModal} rezdyId={data.rezdy_id} onReviewSubmitted={onReviewSubmitted} />

        {/* <div className={s.reviewDetail}>
          <span><FontAwesomeIcon icon={faPaperclip} /> 旅行者タイプ</span>
          <ul>
            {travelerTypes.map((traveler, index) => (
              <li key={index}>{traveler.type}（{traveler.count}）</li>
            ))}
          </ul>
        </div>

        <div className={s.verticalDivider} /> */}

        {/* <div className={s.reviewDetail}>
          <span><FontAwesomeIcon icon={faUser} /> 年齢層</span>
          <ul>
            {ageGroups.map((age, index) => (
              <li key={index}>{age.age}（{age.count}）</li>
            ))}
          </ul>
        </div>

        <div className={s.verticalDivider} />

        <div className={s.reviewDetail}>
          <span><FontAwesomeIcon icon={faVenusMars} /> 性別</span>
          <ul>
            {genders.map((gender, index) => (
              <li key={index}>{gender.gender}（{gender.count}）</li>
            ))}
          </ul>
        </div> */}
      </div>
      {reviews.length > reviewsPerPage && ( // ページネーションが必要な場合に表示
          <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
          />
      )}
    </div>
  );
};

export default ReviewSummary;
